import { Insert16 } from 'ui/icons/aurora/16px/Insert16';
import { colors } from 'ui/theme/colors';
import { BadgeWrapper } from '../../LocaleSwitcher.styled';

export const AddLocale = ({ text }: { text: string }) => (
  <BadgeWrapper data-test="add-locale">
    <Insert16 color={colors.textInteractive} />
    {text}
  </BadgeWrapper>
);
